// src/lib/permissionNames.ts
//
// مولَّد آليًّا من سجلّ الصلاحيات الوحيد (mcenter-backend/app/services/permissions.py).
// لا تحرّره يدويًّا: شغّل `python scripts\gen_permission_names.py` في mcenter-backend.
// يحرسه tests/test_permission_names_map.py — أيّ اختلاف عن السجلّ يُسقطه.

/** الاسم العربيّ لكلّ صلاحية، كما في السجلّ */
export const PERMISSION_NAMES_AR: Readonly<Record<string, string>> = {
  "tv.manage": "إدارة وإعداد القنوات الفضائية",
  "tv.delete": "حذف القنوات الفضائية",
  "tv.view": "عرض واختيار شاشات القنوات الفضائية",
  "tv.record": "إدارة تسجيلات القنوات الفضائية (بدء وجدولة)",
  "radio.manage": "إدارة وإعداد القنوات الإذاعية",
  "radio.delete": "حذف القنوات الإذاعية",
  "radio.view": "عرض واختيار شاشات القنوات الإذاعية",
  "radio.record": "إدارة تسجيلات القنوات الإذاعية (بدء وجدولة)",
  "programs.speechmatics": "استخدام Speechmatics",
  "programs.whisper": "استخدام Whisper",
  "programs.deepgram": "استخدام Deepgram",
  "jobs.create": "إنشاء مهام التفريغ",
  "jobs.view": "عرض مهام التفريغ الخاصة",
  "jobs.delete": "حذف مهام التفريغ الخاصة",
  "transcription.manage_all": "عرض وإدارة كل مهام التفريغ وملفاتها",
  "live.manage": "إنشاء جلسة تفريغ بث مباشر",
  "live.view": "عرض أرشيف البث المباشر الخاص",
  "live.delete": "حذف جلسات البث المباشر الخاصة",
  "live.manage_all": "عرض وإدارة كل جلسات البث المباشر وملفاتها",
  "translate.view": "عرض الترجمة",
  "translate.manage": "تعديل الترجمة",
  "translate.delete": "حذف الترجمة",
  "news.view": "عرض الأخبار",
  "news.manage": "تعديل الأخبار",
  "news.delete": "حذف الأخبار",
  "articles.view": "عرض المقالات",
  "articles.manage": "تعديل المقالات",
  "articles.delete": "حذف المقالات",
  "campaigns.view": "عرض الحملات",
  "campaigns.manage": "تعديل الحملات",
  "campaigns.delete": "حذف الحملات",
  "reports.view": "عرض التقارير",
  "tools.use": "استخدام الأدوات الذكية",
  "mp.guide": "عرض دليل ميديا بلص",
  "mp.dashboard": "عرض لوحة معلومات ميديا بلص",
  "mp.concerns": "إدارة الاهتمامات",
  "mp.sources": "إدارة المصادر والجمع",
  "mp.collect": "إدارة جلسات الجمع",
  "mp.search": "البحث في المحتوى",
  "mp.monitoring": "إدارة مشاريع الرصد",
  "mp.monitor_rules": "إدارة قواعد الرصد التلقائي",
  "mp.alerts": "إدارة التنبيهات",
  "mp.rumors": "متابعة الشائعات",
  "mp.influencers": "متابعة المؤثرين",
  "mp.campaigns": "متابعة الحملات المنسّقة",
  "mp.stories": "إدارة مجموعات القصص",
  "mp.ai_processing": "المعالجة بالذكاء الاصطناعي",
  "mp.reports": "إدارة تقارير الرصد",
  "mp.sessions": "إدارة جلسات العمل",
  "mp.settings": "تعديل إعدادات ميديا بلص",
  "mp.delete": "حذف محتوى ميديا بلص",
  "media_watch.view": "عرض رصد السوشيال",
  "media_watch.manage": "إدارة رصد السوشيال",
  "media_watch.delete": "حذف رصد السوشيال",
  "media_watch.review": "مراجعة حالات التحريض",
  "media_watch.triage": "فرز البلاغات",
  "media_watch.settings": "إعدادات رصد السوشيال",
  "settings.view": "عرض الإعدادات",
  "settings.edit": "تعديل الإعدادات",
  "permissions.view": "عرض الصلاحيات",
  "permissions.edit": "تعديل الصلاحيات",
  "database.view": "عرض قاعدة البيانات",
  "database.edit": "تعديل قاعدة البيانات",
  "backup.view": "عرض النسخ الاحتياطية",
  "backup.manage": "إنشاء النسخ الاحتياطية",
  "backup.delete": "حذف النسخ الاحتياطية",
  "backup.restore": "استعادة نسخة احتياطية",
  "trash.view": "عرض سلة المحذوفات",
  "trash.empty": "إفراغ سلة المحذوفات",
  "trash.restore": "استعادة من المحذوفات",
  "trash.purge": "حذف نهائي مفرد من المحذوفات",
  "users.manage": "إدارة المستخدمين",
  "users.unlock": "فكّ قفل المستخدمين",
  "servers.view": "عرض السيرفرات",
  "servers.manage": "تعديل السيرفرات",
  "servers.delete": "حذف السيرفرات",
  "system.view": "عرض معلومات النظام",
  "operations.view": "عرض دليل التشغيل",
  "activity.view": "عرض سجل النشاط",
  "ai.use": "التحليل بالذكاء الاصطناعي",
  "ai.delete": "حذف الكيانات المراقبة",
  "ai.publish": "النشر إلى المنصّات",
  "ai.prompts": "تعديل برومبتات التحليل",
};

/** اسم الصلاحية بالعربية، أو رمزها إن كانت غير معروفة */
export function permissionNameAr(code: string): string {
  return PERMISSION_NAMES_AR[code] || code;
}
